import { createReducer, on } from '@ngrx/store';
import { map } from 'lodash-es';

import { GatewayInvitationsActions } from './gateway-invitations.actions';
import { GatewayInvitationsState } from './gateway-invitations.state';

export const gatewayInvitationsInitState: GatewayInvitationsState = {
  invitations: {},
  invitationsIds: [],
  inviterDetails: {},
  inviteeDetails: {},
  inviteeCompanyDetails: {},
  inviterCompanyDetails: {},
  installationId: null,
  links: null,
  isData: false,
  loading: false,
  loaded: false,
  error: null,
};

/* eslint-disable */
export const gatewayInvitationsReducer = createReducer(
  gatewayInvitationsInitState,

  on(GatewayInvitationsActions.listGatewayInvitations, (state, { installationId }) => {
    const cachedInstallationId = state.installationId;

    return {
      ...state,
      installationId,
      isData: cachedInstallationId === installationId,
      loading: true,
      error: null,
      links: null,
    };
  }),

  on(GatewayInvitationsActions.listGatewayInvitationsSuccess, (state, { invitations, next }) => {
    const cachedInvitations = map(state.invitations, (invitation) => invitation);
    const invitationsList = [...cachedInvitations, ...invitations];
    const ids = invitationsList.map((invitation) => invitation.token);

    invitationsList.forEach((invitation) => {
      state.invitations[invitation.token] = invitation;
    });

    return {
      ...state,
      invitationsIds: ids,
      isData: !!invitationsList.length,
      links: { next },
      loading: false,
      loaded: true,
    };
  }),

  on(GatewayInvitationsActions.listGatewayInvitationsError, (state) => {
    return {
      ...state,
      isData: false,
      loading: false,
      loaded: true,
    };
  }),

  on(GatewayInvitationsActions.getInviterDetailsSuccess, (state, { accountId, response }) => {
    state.inviterDetails[accountId] = response;

    return {
      ...state,
    };
  }),

  on(GatewayInvitationsActions.getInviteeDetailsSuccess, (state, { accountId, response }) => {
    state.inviteeDetails[accountId] = response;

    return {
      ...state,
    };
  }),

  on(GatewayInvitationsActions.getInviteeCompanyDetailsSuccess, (state, { companyId, data }) => {
    state.inviteeCompanyDetails[companyId] = {
      id: data.id,
      companyName: data.name,
    };

    return {
      ...state,
    };
  }),

  on(GatewayInvitationsActions.getInviterCompanyDetailsSuccess, (state, { companyId, data }) => {
    state.inviterCompanyDetails[companyId] = {
      id: data.id,
      companyName: data.name,
    };

    return {
      ...state,
    };
  }),

  on(GatewayInvitationsActions.filterByStatus, (state) => ({
    ...state,
    invitations: {},
    invitationsIds: [],
    loading: true,
  })),

  on(GatewayInvitationsActions.clearStore, (state) => {
    // clear invitation lists but leave invitee and inviter details for caching purpose
    return {
      ...state,
      invitations: {},
      invitationsIds: [],
      installationId: null,
      isData: false,
      loading: true,
      loaded: false,
    };
  })
);
